import { AccountOrders } from 'features/account/orders';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { AccountOrders as LegacyAccountOrders } from 'pages/account/account-orders/account-orders';
import AuthRequired from 'pages/authentication/components/auth-required';

export default function AccountOrdersPage() {
  const enableMinimalCartUi = useMinimalCartUi();

  return (
    <AuthRequired>{enableMinimalCartUi ? <AccountOrders /> : <LegacyAccountOrders />}</AuthRequired>
  );
}
